export default "{\n    \"inputPlaceholder\": \"Saisissez votre message\",\n    \"uploadFileLabel\": \"Téléverser depuis l'appareil\"\n}\n"